import {TagSchema} from 'constants/RegistryConstants';
import {Tag} from 'folder-items/FileConstants';
import {writeFragmentsToCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {graphQLToREST, restToGraphQL} from 'graphql-client/declarative-translations/external/translate';
import ExtractByTypename from 'graphql-client/ExtractByTypename';

import {BaseFolderItemFileGraphQL} from '../../graphql-fragments/nav/folder-items/__generated/BaseFolderItemFileGraphQL';
import ApolloFolderItemBase from './ApolloFolderItemBase';

type BaseFolderItemFileGraphQL_BasicFolderItemNode = ExtractByTypename<
  BaseFolderItemFileGraphQL,
  'BasicFolderItemNode'
>;

type BaseFolderItemFileGraphQL_EntryNode = ExtractByTypename<BaseFolderItemFileGraphQL, 'EntryNode'>;

type TagSchemaFolderItemGraphQL =
  | BaseFolderItemFileGraphQL_BasicFolderItemNode
  | BaseFolderItemFileGraphQL_EntryNode;

export default abstract class ApolloHasTagSchemaFolderItemBase<
  TQuery,
  TFolderItemGraphQL extends TagSchemaFolderItemGraphQL,
> extends ApolloFolderItemBase<TQuery, TFolderItemGraphQL> {
  protected queryVariables(): {fileId: string} {
    return {fileId: this.id};
  }

  override tags(): Array<Tag> {
    return this.folderItem().tagsJson;
  }

  override tagSchema(): TagSchema | null {
    const tagSchemaGql = this.folderItem().tagSchema;
    return tagSchemaGql != null ? graphQLToREST('TagSchema', tagSchemaGql) : null;
  }

  override setTags(tags: Array<Tag>): void {
    writeFragmentsToCache(getFragmentWrapper('UpdateFolderItemTags'), [
      {__typename: this.folderItem().__typename, id: this.folderItem().id, tagsJson: tags},
    ]);
  }

  override setTagSchema(tagSchema: TagSchema | null): void {
    const gqlTagSchema = tagSchema == null ? null : restToGraphQL('TagSchema', tagSchema);
    writeFragmentsToCache(getFragmentWrapper('UpdateFolderItemTagSchema'), [
      {
        __typename: this.folderItem().__typename,
        id: this.folderItem().id,
        tagSchema: gqlTagSchema,
      },
    ]);
  }
}
